import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home/HomeView.vue'

const DatasetView = () => import('../views/Dataset/DatasetView.vue')
const MarkerView = () => import('../views/Marker/MarkerView.vue')
const GeneView = () => import('../views/Marker/GeneView.vue')
const BlastView = () => import('../views/Tools/BlastView.vue')
const CompCtView = () => import('../views/Tools/CompCtView.vue')
const PredCtView = () => import('../views/Tools/PredCtView.vue')
const HelpView = () => import('../views/Help/HelpView.vue')
const SearchResultView = () => import('../views/Search/SearchResultView.vue')
const NotFoundView = () => import('../components/error/NotFound.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: 'Home page of scPlantDB',
      keepAlive : true 
    },
    component: HomeView
  },
  {
    path: '/dataset',
    name: 'dataset',
    meta: {
      keepAlive : true 
    },
    component: DatasetView
  },
  {
    path: '/marker',
    name: 'marker',
    meta: {
      keepAlive : true 
    },
    component: MarkerView
  },
  {
    path: '/gene',
    name: 'gene',
    meta: {
      keepAlive : false 
    },
    component: GeneView
  },
  {
    path: '/tools/blast',
    name: 'blast',
    meta: {
      keepAlive : true 
    },
    component: BlastView
  },
  {
    path: '/tools/compct',
    name: 'compct',
    meta: {
      keepAlive : true 
    },
    component: CompCtView
  },
  {
    path: '/tools/predct',
    name: 'predct',
    meta: {
      keepAlive : true 
    },
    component: PredCtView
  },
  {
    path: '/help',
    name: 'help',
    meta: {
      keepAlive : true 
    },
    component: HelpView
  },
  {
    path: '/search',
    name: 'search',
    component: SearchResultView
  },
  {
    path: '/404',
    name: '404_error',
    component: NotFoundView
  },
  {
    path: '*',
    redirect: '/404'
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes
})

export default router
